'use strict';

import Dispatcher from './../Dispatcher';
import Constants from './../Constants';

const ActionTypes = Constants.ActionTypes;

const ActionCreator = {
	Messenger: {
		selectChannelById: function (channelId, touchChannel, isRestored) {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.SELECT_CHANNEL,
				channelId: channelId,
				touchChannel: touchChannel,
				isRestored: isRestored,
			});
		},

		selectChannelByActorId: function (actorId, touchChannel, isRestored, shouldSelect) {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.SELECT_CHANNEL,
				actorId: actorId,
				touchChannel: touchChannel,
				isRestored: isRestored,
				shouldSelect: shouldSelect,
			});
		},

		unselectChannel: function () {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.UNSELECT_CHANNEL,
			});
		},

		filterOnlineChannels: function (active) {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.FILTER_ONLINE_CHANNELS,
				active: active,
			});
		},

		addGiftToMessage: function (giftId) {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.ADD_GIFT_TO_MESSAGE,
				giftId: giftId,
			});
		},

		updateRecommendedActors: function (currentActorId, fsk) {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.UPDATE_RECOMMENDED_ACTORS,
				currentActorId: currentActorId,
				fsk: fsk,
			});
		},

		updateRecommendedActorsGrid: function (currentActorId) {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.UPDATE_RECOMMENDED_ACTORS_GRID,
				currentActorId: currentActorId,
			});
		},

		setAllMessagesRead: function () {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.SET_ALL_MESSAGES_READ,
			});
		},

		setRestorePreviousUrl: function (restorePreviousUrl) {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.SET_RESTORE_PREVIOUS_URL,
				restorePreviousUrl: restorePreviousUrl,
			});
		},

		removeGiftFromMsg: function (giftId) {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.REMOVE_GIFT_FROM_MESSAGE,
				giftId,
			});
		},

		setUnreadMessagesCount: function (unreadCount) {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.SET_UNREAD_MESSAGES_COUNT,
				unreadCount,
			});
		},

		setIsChatExitOpen: function (isOpen) {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.SET_IS_CHAT_EXIT_OPEN,
				isOpen: isOpen,
			});
		},

		buyChatTicket: function (ticket, creationType = Constants.TicketCreationType.CHAT_TICKET) {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.BUY_CHAT_TICKET,
				ticket: ticket,
				creationType: creationType,
			});
		},

		removeChatTicket: function (ticket) {
			Dispatcher.dispatch({
				type: ActionTypes.Messenger.REMOVE_CHAT_TICKET,
				ticket: ticket,
			});
		},
	},

	Notification: {
		sendMessage: function (channelId, senderType, messageType, isVideochat, isFreechat, data, includedGifts, chatId) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.SEND_MESSAGE,
				channelId: channelId,
				senderType: senderType,
				messageType: messageType,
				isVideochat: isVideochat,
				isFreechat: isFreechat,
				data: data,
				includedGifts: includedGifts,
				chatId: chatId,
			});
		},

		setAllChannelsSeen: function () {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.SET_ALL_CHANNELS_SEEN,
			});
		},

		loadMoreChannels: function (limit, offset) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.LOAD_MORE_CHANNELS,
				offset: offset,
				limit: limit,
			});
		},

		loadOnlineChannels: function (online) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.LOAD_ONLINE_CHANNELS,
				online: online,
			});
		},

		filterChannels: function (filterType) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.FILTER_CHANNELS,
				filterType: filterType,
			});
		},

		canOneClick: function () {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.CAN_ONECLICK,
			});
		},

		chargeOneClick: function (amount, channelId) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.CHARGE_ONECLICK,
				amount: amount,
				channelId: channelId,
			});
		},

		markNavbarNotificationAsRead: function (notificationId) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.MARK_NAVBAR_NOTIFICATION_AS_READ,
				notificationId: notificationId,
			});
		},

		markNavbarNotificationAsSeen: function (notificationId) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.MARK_NAVBAR_NOTIFICATION_AS_SEEN,
				notificationId: notificationId,
			});
		},

		markFloatingNotificationAsRead: function (notificationId) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.MARK_FLOATING_NOTIFICATION_AS_READ,
				notificationId: notificationId,
			});
		},

		refreshEmailProperties: function () {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.REFRESH_EMAIL_PROPERTIES,
			});
		},

		passwordChanged: function () {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.PASSWORD_CHANGED,
			});
		},

		sendSignupEmail: function (email) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.SEND_SIGNUP_EMAIL,
				email: email,
			});
		},

		sendEmailBouncedResetMail: function (email) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.SEND_SIGNUP_EMAIL,
				email: email,
				sendBouncedTpl: true,
			});
		},

		pinActor: function (actorId) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.FAVORITE_PIN_ACTOR,
				actorId: actorId,
			});
		},

		unpinActor: function (actorId) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.FAVORITE_UNPIN_ACTOR,
				actorId: actorId,
			});
		},

		setPinnedActorEmailNotification: function (actorId, enabled) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.FAVORITE_SET_PINNED_ACTOR_EMAIL_NOTIFICATION,
				actorId: actorId,
				enabled: enabled,
			});
		},

		setPinnedActorSMSNotification: function (actorId, enabled) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.FAVORITE_SET_PINNED_ACTOR_SMS_NOTIFICATION,
				actorId: actorId,
				enabled: enabled,
			});
		},

		pinSedcards: function (actorId) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.FAVORITE_PIN_SEDCARDS,
				actorId: actorId,
			});
		},

		pinAlbum: function (albumId) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.FAVORITE_PIN_ALBUM,
				albumId: albumId,
			});
		},

		unpinAlbum: function (albumId) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.FAVORITE_UNPIN_ALBUM,
				albumId: albumId,
			});
		},

		pinPicture: function (pictureId) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.FAVORITE_PIN_PICTURE,
				pictureId: pictureId,
			});
		},

		unpinPicture: function (pictureId) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.FAVORITE_UNPIN_PICTURE,
				pictureId: pictureId,
			});
		},

		archiveChannel: function (channelId, status) {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.ARCHIVE_CHANNEL,
				channelId: channelId,
				status: status,
			});
		},

		removeStatusBar: function () {
			Dispatcher.dispatch({
				type: ActionTypes.Notification.REMOVE_STATUS_BAR,
			});
		},
	},

	TileGrid: {
		loadGrid: function (type, payload, useInfiniteScrolling) {
			Dispatcher.dispatch({
				type: ActionTypes.TileGrid.LOAD_GRID,
				gridType: type,
				payload: payload,
				useInfiniteScrolling: useInfiniteScrolling,
			});
		},

		loadVideoAlbumPictures: function (albumId) {
			Dispatcher.dispatch({
				type: ActionTypes.TileGrid.LOAD_VIDEO_ALBUM_PICTURES,
				albumId: albumId,
			});
		},

		resetScrollPosition: function (tileGridId) {
			Dispatcher.dispatch({
				type: ActionTypes.TileGrid.RESET_SCROLL_POSITION,
				tileGridId: tileGridId,
			});
		},

		resetBackLink: function (tileGridId) {
			Dispatcher.dispatch({
				type: ActionTypes.TileGrid.RESET_BACK_LINK,
				tileGridId: tileGridId,
			});
		},

		setBackLink: function (tileGridId) {
			Dispatcher.dispatch({
				type: ActionTypes.TileGrid.SET_BACK_LINK,
				tileGridId: tileGridId,
			});
		},

		setRestoreScrollPosition: function (restorePosition) {
			Dispatcher.dispatch({
				type: ActionTypes.TileGrid.SET_RESTORE_SCROLL_POSITION,
				restorePosition: restorePosition,
			});
		},

		setScrollPosition: function (tileGridId, offset) {
			Dispatcher.dispatch({
				type: ActionTypes.TileGrid.SET_SCROLL_POSITION,
				offset: offset,
				tileGridId: tileGridId,
			});
		},

		setTileGridKey: function (tileGridId, tileGridKey) {
			Dispatcher.dispatch({
				type: ActionTypes.TileGrid.SET_TILE_GRID_KEY,
				tileGridId: tileGridId,
				tileGridKey: tileGridKey,
			});
		},

		setTileGridMode: function (tileGridId, gridMode) {
			Dispatcher.dispatch({
				type: ActionTypes.TileGrid.SET_TILE_GRID_MODE,
				tileGridId: tileGridId,
				gridMode: gridMode,
			});
		},
	},
};

export default ActionCreator;
